const initialState = {
  content: ''
};

const modal = (state: any = initialState, action: any) => {
  switch (action.type) {
    case 'SET_CONTENT':
      return {
        ...state,
        content: action.content
      };
    case 'CLEAR_CONTENT':
      return {
        ...state,
        content: ''
      };
    default:
      return state;
  }
};

export default modal;
